import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '@quickbee/auth';

/**
 * Route guard over the real session (design doc §5.2). While the silent
 * bootstrap (`initAuthSession`) is still resolving, render a spinner rather
 * than deciding — redirecting before the refresh answers would bounce every
 * page reload through /auth/login.
 */
export default function AuthGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-amber-500 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
}
